import { useMemo } from 'react';

import { UserRoles } from 'app/constants/user';
import { useIsInAnyRole } from 'app/state/AuthContext/hooks';

export const useIsNewDashboardEnabled = () => {
  const isFullyAuthorized = useIsInAnyRole([UserRoles.Underwriting, UserRoles.FraudManager]);

  const isCsr = useIsInAnyRole([UserRoles.Csr, UserRoles.IbexCsr, UserRoles.TbcCsr]);

  return useMemo(() => {
    if (isFullyAuthorized) {
      return true;
    }
    // We want to keep this as an if-condition for future compatibility with new conditions.
    if (isCsr) {
      return true;
    }

    return false;
  },
  [
    isFullyAuthorized,
    isCsr,
  ]);
};
